module.exports = __webpack_public_path__ + "img/logo-sc-negro.e00ca690.png";